import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { CompanyService } from 'app/modules/components/configuration/company/company.service.service';
import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';

@Pipe({
  name: 'decimalStockCompany',
  standalone: true,
  pure: true,
})
export class DecimalStockCompanyPipe implements PipeTransform {
  constructor(
    private companyService: CompanyService
  ) {}

  transform(value: number): string | null {
    if (value == null) return '0.000';
    
    const company : CompanyAttributes = this.companyService.getActiveCompany();

    return value.toFixed(company.stockDecimalsDisplay);
  }
}
